export { default } from './useLazyRef';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/useLazyRef/index.js
// module id = 1608
// module chunks = 22